export const WageRangerDefaultEmployeeValues = [
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 13.84,
                low: 0
            },
            annual: {
                high: undefined,
                low: 0
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 17.99,
                low: 13.85
            },
            annual: {
                high: 37439,
                low: 28808
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 21.99,
                low: 18
            },
            annual: {
                high: 45759,
                low: 37440
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 25.99,
                low: 22
            },
            annual: {
                high: 54079,
                low: 45760
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 32.99,
                low: 26
            },
            annual: {
                high: 68639,
                low: 54080
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 47.99,
                low: 33
            },
            annual: {
                high: 99839,
                low: 68640
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: undefined,
                low: 48
            },
            annual: {
                high: undefined,
                low: 99839
            }
        }
    }
];
export const WageRangerDefaultContractorValues = [
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 13.84,
                low: 0
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 17.99,
                low: 13.85
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 21.99,
                low: 18
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 25.99,
                low: 22
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 32.99,
                low: 26
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: 47.99,
                low: 33
            }
        }
    },
    {
        total: undefined,
        ft: undefined,
        pt: undefined,
        meta: {
            hour: {
                high: undefined,
                low: 48
            }
        }
    }
];
